import React from 'react'

import { InfoTooltip, PriceString } from '@fourthwall/components'
import type { Money } from '@fourthwall/services/dist/models/common'

import * as S from './SamplesCreditBalance.styled'

type SamplesCreditBalanceProps = {
  label: string
  balance: Money
  tooltip?: string
}

export const SamplesCreditBalance = ({ label, balance, tooltip }: SamplesCreditBalanceProps) => (
  <S.Container>
    {label}: <PriceString value={balance.value} currency={balance.currency} />
    {tooltip && (
      <S.TooltipContainer>
        <InfoTooltip content={tooltip} />
      </S.TooltipContainer>
    )}
  </S.Container>
)
